// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"99f0e0c0417c8c279ba4","293":"2d4212ee710f3b02829e","518":"faaf54e241212421f097","779":"283724ca41a73c559bad"}[chunkId] + ".js";
};